import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import Skeleton from './Skeleton';

/**
 * DashboardWidgetSkeleton - Loading placeholder for dashboard widgets/cards
 * 
 * Generic widget with:
 * - Title
 * - Primary stat
 * - Secondary stats
 * - Optional chart placeholder
 * 
 * Props:
 * - showChart: boolean (show chart placeholder)
 * 
 * Use this for admin/business dashboard widgets
 * 
 * @version 1.0.0 (Feb 2026)
 */

const DashboardWidgetSkeleton = ({ showChart = false }) => {
  return (
    <Card
      sx={{
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Title */}
        <Skeleton
          variant="text"
          width="50%"
          height={24}
          animation="wave"
          sx={{ mb: 2 }}
        />

        {/* Primary stat */}
        <Skeleton
          variant="text"
          width="40%"
          height={48}
          animation="wave"
          sx={{ mb: 1 }}
        />

        {/* Secondary stats */}
        <Box display="flex" gap={2} mb={showChart ? 3 : 0}>
          <Skeleton
            variant="text"
            width="30%"
            height={20}
            animation="wave"
          />
          <Skeleton
            variant="text"
            width="25%"
            height={20}
            animation="wave"
          />
        </Box>

        {/* Chart placeholder (optional) */}
        {showChart && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={120}
            animation="wave"
            sx={{ borderRadius: '8px' }}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardWidgetSkeleton;
